import React from "react";
import { Link } from "react-router-dom";
import "./sigcss.css";

export default function Signup() {
  return (
    <div className="text-center p-5">
      <h1 className="mb-4  title-effec">Unlock the Flavorful World of Dry Fruits with Us!</h1>
      <p className="lead text-effec" style={{
                    userSelect: "none", 
                    pointerEvents: "none",
                }}>
 We invite you to join our platform by signing up and exploring a diverse range of premium dry fruits, honey, saffron, dates, and quality packing materials. Signing up is a gateway to a world of health and indulgence.
      </p>
    
      <p className="lead text-effec fon" style={{
                    userSelect: "none", 
                    pointerEvents: "none",
                }}>
        Embrace quality, taste, and convenience – sign up today and elevate your dry fruit experience with us. We look forward to serving you with the finest products and ensuring a delightful journey with every bite!
      </p>
      <div>
      <Link to="/publicForm" className="btn btn-success btn-lg rounded-pill px-5 py-3 mt-3 shadow">
          Sign up
        </Link>

      </div>
    </div>
  );
}
